import React, { useEffect, useState } from 'react'
import { FaUserEdit } from 'react-icons/fa'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Card from '../../SharedComponents/Card'
import Spinner from '../../SharedComponents/Spinner'
import axios from 'axios'
import config from '../../../config.json';
import { NotificationManager } from 'react-notifications';
import { parseDateFromAPI } from '../../../helpers/validators';

export default function PaymentsList() {
    const [loading, setLoading] = useState(false)
    const { id } = useParams();
    const [allPayments, setAllPayments] = useState([]);
    const [payments, setPayments] = useState([]);
    const [selectedSystem, setSelectedSystem] = useState('1');
    const [showSystemFilter, setShowSystemFilter] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        getPayments();
    }, [])

    const getPayments = () => {
        setLoading(true);
        axios({
            method: 'get',
            url: `${config.SERVER_URL}/patients/${id}/payments`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token')
            },
        })
            .then(res => {
                if (typeof (res.data) === "string") {
                    NotificationManager.info(res.data)
                } else {
                    setAllPayments(res.data);
                    filterBySystem(res.data, selectedSystem);
                }

            })
            .catch(err => {
                if (err.response.status === 401) {
                    navigate('/signin')
                }
                NotificationManager.error(err.response.data)
            })
            .finally(() => setLoading(false));
    }

    const filterBySystem = (data, filter) => {
        if (filter === 'all') {
            setPayments(data);
        } else {
            let filterValue = false;
            if (filter === '2') {
                filterValue = true;
            }
            setPayments(data.filter(p => p.is_secondary == filterValue))
        }
    }

    const handleSystemChange = (e) => {
        setSelectedSystem(e.target.value);
        filterBySystem(allPayments, e.target.value)
    }


    return (
        <>
            {loading ? <Spinner /> : null}
            <Card title={'Плаќања'}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                    {showSystemFilter &&
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                            <span style={{ marginRight: '10px' }}>Филтрирај по системи:</span>
                            <select name="system_filter" value={selectedSystem} onChange={handleSystemChange} style={{ padding: '3px', width: '200px' }}>
                                <option value='1'>Систем 1</option>
                                <option value='2'>Систем 2</option>
                                <option value='all'>Систем 1 + Систем 2</option>
                            </select>
                        </div>
                    }
                    <button
                        onClick={() => setShowSystemFilter(!showSystemFilter)}
                        style={{
                            padding: '5px 10px',
                            cursor: 'pointer',
                            backgroundColor: 'white',
                            color: '#39828f',
                            border: 'none',
                            borderRadius: '5px',
                            fontSize: '12px'
                        }}
                    >
                        {showSystemFilter ? '▲' : '▼'}
                    </button>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Датум на услуга</th>
                            <th scope="col">Услуга</th>
                            <th scope="col">Наплатен износ</th>
                            <th scope="col" style={{ width: '10px', paddingTop: '0' }}>
                                <Link to='add' type="button" className="btn align-self-end" style={{ backgroundColor: "#39828f", color: "#fff" }}>+</Link>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {payments.map((payment, index) => {
                            const paymentDate = parseDateFromAPI(payment.date_of_service);
                            return (
                                <tr key={payment.id}>
                                    <td>{`${paymentDate.getDate()}/${paymentDate.getMonth() + 1 < 10 ? '0' + (paymentDate.getMonth() + 1) : (paymentDate.getMonth() + 1)}/${paymentDate.getFullYear()}`}</td>
                                    <td style={{ maxWidth: '900px', maxHeight: '47px', overflow: 'hidden' }}>{payment.service}</td>
                                    <td style={{ textAlign: 'center' }}><span className={payment.payment_rest < 1 ? '' : 'text-danger'}>{payment.payment_amount}</span></td>

                                    <td style={{ width: '50px', paddingTop: '0' }}>
                                        <Link to={`${payment.id}`} type="button" className="btn">
                                            <FaUserEdit style={{ color: '#39828f' }} />
                                        </Link>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </table>
            </Card>
        </>
    )
}
